<template>
  <div class="product">
    <div class="head">
      <slot></slot>
    </div>
    <div class="list">
      <ul>
        <li v-for="(item, index) of goodsInfo" :key="index">
          <router-link :to="{ name: 'prodetail', query: { pid: item.goods_sn } }">
            <div class="p-img"><img :src="item.pic" /></div>
            <div class="name">
              <p>{{ item.goods_name }}</p>
            </div>

          </router-link>
          <div class="p-bottom">
            <div class="price">{{ $setInfoDecimal(item.goods_price) }}</div>
            <div class="addcar">
              <button @click="addcar(item.goods_sn)"></button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { addcar } from '@/api/car'


export default {
  props: {
    goodsInfo: {
      type: Array
    }
  },
  methods: {
    async addcar (id) {
      const result = await addcar({
        goods_sn: id,
        num: 1
      })
      this.$toast(result.data.data.message)
    }
  },
}
</script>
<style lang="scss" scoped>
.product {
  font-size: 0.32rem;
  .head {
    margin: 0.2rem;
  }
}
.list {
  font-size: 0.24rem;
  ul {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 2rem;
    li {
      a {
        color: #000;
      }
      width: 1.92rem;
      margin: 0.1rem 0.15rem;
      background: white;
      padding: 0.2rem;
      border-radius: 10px;
    }
    .price {
      color: #ff3131;
      font-size: 0.25rem;
    }
    .p-img {
      width: 100%;
      height: 1.72rem;
    }
    .name {
      height: 0.67rem;
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      p {
        margin: 0;
      }
    }
    .p-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;
    }
    .p-type {
      span {
        display: inline;
        border-radius: 30px;
        border: 1px solid #ff6161;
        color: #ff6161;
        font-size: 0.18rem;
        padding: 0.03rem 0.09rem;
        margin: 0 0.02rem;
      }
    }
    .addcar {
      button {
        width: 0.32rem;
        height: 0.32rem;
        background: url('../../../assets/icon/addcar.png') no-repeat;
        background-size: 0.32rem;
        border: none;
      }
    }
  }
}
</style>